/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: remote-file-select-service.ts
 */

// This service is an implementation for FileSelectService.
// Components should invoke the abstract FileSelectService, not this specific implementation.

angular.module('prism-ui.components').service('RemoteFileSelectService', function (
    this: JS5Object,
    _: JS5Object,
    FileSelectService: JS5Object,
    ModalService: JS5Object,
) {

    //=================//
    // Lifecycle Hooks //
    //=================//

    this.initialize = (fileSelectConfig: JS5Object) => {
        // Nothing to initialize
    };

    this.onFileChanged = (fileSelectConfig: JS5Object, newFileValue: JS5Object) => {
        // No response needed
    };

    this.cleanup = (fileSelectConfig: JS5Object) => {
        // Nothing to clean up
    };


    //========================//
    // Remote File Validation //
    //========================//

    this.promptFile = (fileSelectConfig: JS5Object, options: any) => {
        let fileExtensions = fileSelectConfig.getFileExtensions();
        ModalService.showFileSelectionModal(fileExtensions, (virtualPath: string) => {
            onValidRemoteFileSelected(fileSelectConfig, virtualPath);
        }, (fileSystemItem: JS5Object) => {
            return fileSelectConfig.validateRemoteFile({fileSystemItem});
        });
    };

    const onValidRemoteFileSelected = (fileSelectConfig: JS5Object, virtualPath: string) => {
        FileSelectService.completeValidation(
            fileSelectConfig,
            'REMOTE',
            [{virtualPath: virtualPath}],
            [{
                source: virtualPath,
                errors: [],
                warnings: []
            }]
        );
    };
});


//=================//
// Lifecycle Hooks //
//=================//

// Load this service when app is initialized
angular.module('prism-ui.components').run((
    FileSelectService: JS5Object,
    RemoteFileSelectService: JS5Object,
) => {
    FileSelectService.registerFileSelectServiceImplementation('REMOTE', RemoteFileSelectService);
});
